"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";

import clsx from "clsx";

function getPagesToShow(page: number, pageCount: number) {
  const result = [];
  if (pageCount - page < 4) {
    for (let p = pageCount - 4; p <= pageCount; p++) {
      if (p > 0) {
        result.push(p);
      }
    }
  } else if (page < 4) {
    for (let p = 1; p <= page + 4; p++) {
      if (p <= pageCount && p <= 5) {
        result.push(p);
      }
    }
  } else {
    for (let p = 1; p <= pageCount; p++) {
      if (Math.abs(p - page) < 3) {
        result.push(p);
      }
    }
  }
  return result;
}

function getLinkComponent(
  page: number,
  label: number | string,
  pageClassName: string,
) {
  return (
    <Link
      href={`?page=${page}`}
      className={clsx(
        "block aspect-square w-6 text-center transition-colors duration-200",
        pageClassName,
      )}
    >
      {label}
    </Link>
  );
}

export default function Pager({
  pageCount,
  className = "",
  pageClassName = "hover:text-blue-600",
  activePageClassName = "",
}: {
  pageCount: number;
  query?: object;
  className?: string;
  pageClassName?: string;
  activePageClassName?: string;
}) {
  const params = useSearchParams();
  const page = parseInt(params.get("page") ?? "1");
  const pagesToShow = getPagesToShow(page, pageCount);

  return (
    <div className={clsx("mx-auto mt-4 inline-flex items-center", className)}>
      {page !== 1 && getLinkComponent(1, "<<", pageClassName)}

      {page >= 2 && getLinkComponent(page - 1, "<", pageClassName)}

      {Array.from({ length: pageCount }, (_, k) => k + 1).map((p) => (
        <div key={"page-" + p}>
          {p === page ? (
            <div
              className={clsx(
                "block aspect-square w-6 text-center font-bold",
                activePageClassName,
              )}
            >
              {p}
            </div>
          ) : (
            pagesToShow.includes(p) && getLinkComponent(p, p, pageClassName)
          )}
        </div>
      ))}

      {page < pageCount && getLinkComponent(page + 1, ">", pageClassName)}

      {page < pageCount && getLinkComponent(pageCount, ">>", pageClassName)}
    </div>
  );
}
